import { ActivityCollection, ActivityEndpoints } from "./collections/activity";
import { AdminCollection, AdminEndpoints } from "./collections/admin";
import { AuthCollection, AuthEndpoints } from "./collections/auth";
import {
  AuthorizationCollection,
  AuthorizationEndpoints,
} from "./collections/authorization";
import { BlogCollection, BlogEndpoints } from "./collections/blog";
import { BookingCollection, BookingEndpoints } from "./collections/booking";
import { CRSCollection, CRSEndpoints } from "./collections/crs";
import { DiscoverCollection, DiscoverEndpoints } from "./collections/discover";
import { FeedbackCollection, FeedbackEndpoints } from "./collections/feedback";
import { GeetaCollection, GeetaEndpoints } from "./collections/geeta";
import {
  OldFeedbackCollection,
  OldFeedbackEndpoints,
} from "./collections/old-feedback";
import { OwnerCollection, OwnerEndpoints } from "./collections/owner";
import { PaymentCollection, PaymentEndpoints } from "./collections/payment";
import { PlacesCollection, PlacesEndpoints } from "./collections/places";
import { PMSCollection, PMSEndpoints } from "./collections/pms";
import { ProfileCollection, ProfileEndpoints } from "./collections/profile";
import {
  ZoProfileCollection,
  ZoProfileEndpoints,
} from "./collections/profilezo";
import {
  RZPPaymentCollection,
  RZPPaymentEndpoints,
} from "./collections/rzp-payment";
import { StayCollection, StayEndpoints } from "./collections/stay";
import { SupplyCollection, SupplyEndpoints } from "./collections/supply";
import { TrackingCollection, TrackingEndpoints } from "./collections/tracking";
import { WalletCollection, WalletEndpoints } from "./collections/wallet";
import { WebAppCollection, WebAppEndpoints } from "./collections/webapp";
import { WhatsAppCollection, WhatsAppEndpoints } from "./collections/whatsapp";
import { ZoAuthCollection, ZoAuthEndpoints } from "./collections/zoauth";
import { ZobuCollection, ZobuEndpoints } from "./collections/zobu";
import {
  ZODiscoverCollection,
  ZODiscoverEndpoints,
} from "./collections/zodiscover";
import {
  ZostelJobsCollection,
  ZostelJobsEndpoints,
} from "./collections/zosteljobs";
import { ZoWorldCollection, ZoWorldEndpoints } from "./collections/zoworld";

type ZoEndpoints =
  | ActivityEndpoints
  | AdminEndpoints
  | AuthEndpoints
  | AuthorizationEndpoints
  | CRSEndpoints
  | DiscoverEndpoints
  | FeedbackEndpoints
  | PaymentEndpoints
  | PlacesEndpoints
  | PMSEndpoints
  | ProfileEndpoints
  | StayEndpoints
  | SupplyEndpoints
  | WalletEndpoints
  | WhatsAppEndpoints
  | ZobuEndpoints
  | GeetaEndpoints
  | ZostelJobsEndpoints
  | BlogEndpoints
  | ZoWorldEndpoints
  | BookingEndpoints
  | RZPPaymentEndpoints
  | ZODiscoverEndpoints;

export type Endpoint =
  | ZoEndpoints
  | WebAppEndpoints
  | TrackingEndpoints
  | OldFeedbackEndpoints
  | OwnerEndpoints
  | ZoAuthEndpoints
  | ZoProfileEndpoints;

type EndpointCollection = { [key in Endpoint]?: string };

const include = (collection: { PATH: string; ENDPOINTS: EndpointCollection }) =>
  Object.fromEntries(
    Object.keys(collection.ENDPOINTS).map((k) => [
      k,
      collection.PATH + collection.ENDPOINTS[k as Endpoint],
    ])
  ) as EndpointCollection;

const ZO_ENDPOINTS: EndpointCollection = [
  ActivityCollection,
  AdminCollection,
  AuthCollection,
  AuthorizationCollection,
  CRSCollection,
  DiscoverCollection,
  FeedbackCollection,
  PaymentCollection,
  PlacesCollection,
  PMSCollection,
  ProfileCollection,
  StayCollection,
  SupplyCollection,
  WalletCollection,
  WhatsAppCollection,
  ZobuCollection,
  GeetaCollection,
  ZostelJobsCollection,
  BlogCollection,
].reduce((z, c) => Object.assign(z, include(c)), {});

const ZOWORLD_ENDPOINTS: EndpointCollection = [
  ZoAuthCollection,
  ZoProfileCollection,
  ZoWorldCollection,
].reduce((z, c) => Object.assign(z, include(c)), {});

const WEBAPP_ENDPOINTS = include(WebAppCollection);
const TRACKING_ENDPOINTS = include(TrackingCollection);
const OWNER_ENDPOINTS = include(OwnerCollection);
const OLD_FEEDBACK_ENDPOINTS = include(OldFeedbackCollection);
const BOOKING_ENDPOINTS = include(BookingCollection);
const RZP_PAYMENT_ENDPOINTS = include(RZPPaymentCollection);
const ZODISCOVER_ENDPOINTS = include(ZODiscoverCollection);
export const getApiEndpoint: (endpoint: Endpoint) => string = (
  endpoint: Endpoint
) => {
  if (endpoint in ZO_ENDPOINTS) {
    return `${process.env.REACT_APP_API_ZO}${ZO_ENDPOINTS[endpoint]}`;
  } else if (endpoint in ZOWORLD_ENDPOINTS) {
    return `${process.env.REACT_APP_API_ZOWORLD}${ZOWORLD_ENDPOINTS[endpoint]}`;
  } else if (endpoint in WEBAPP_ENDPOINTS) {
    return `${process.env.REACT_APP_API_WEBAPP}${WEBAPP_ENDPOINTS[endpoint]}`;
  } else if (endpoint in TRACKING_ENDPOINTS) {
    return `${process.env.REACT_APP_API_TRACKING}${TRACKING_ENDPOINTS[endpoint]}`;
  } else if (endpoint in OWNER_ENDPOINTS) {
    return `${process.env.REACT_APP_API_OWNER}${OWNER_ENDPOINTS[endpoint]}`;
  } else if (endpoint in OLD_FEEDBACK_ENDPOINTS) {
    return `${process.env.REACT_APP_API_OLD_FEEDBACK}${OLD_FEEDBACK_ENDPOINTS[endpoint]}`;
  } else if (endpoint in BOOKING_ENDPOINTS) {
    return `${process.env.REACT_APP_API_ZOWORLD}${BOOKING_ENDPOINTS[endpoint]}`;
  } else if (endpoint in RZP_PAYMENT_ENDPOINTS) {
    return `${process.env.REACT_APP_API_ZOWORLD}${RZP_PAYMENT_ENDPOINTS[endpoint]}`;
  } else if (endpoint in ZODISCOVER_ENDPOINTS) {
    console.log("here");

    return `${process.env.REACT_APP_API_ZOWORLD}${ZODISCOVER_ENDPOINTS[endpoint]}`;
  } else return "";
};
